module.exports = __webpack_public_path__ + "static/media/py.ecef351c.svg";